import { render, staticRenderFns } from "./PaglieraniPrintHeader.vue?vue&type=template&id=f78cb05c&scoped=true&"
import script from "./PaglieraniPrintHeader.vue?vue&type=script&lang=js&"
export * from "./PaglieraniPrintHeader.vue?vue&type=script&lang=js&"
import style0 from "./PaglieraniPrintHeader.vue?vue&type=style&index=0&id=f78cb05c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f78cb05c",
  null
  
)

export default component.exports